<template>
    <div class="mx-2">
        <div class="d-flex justify-content-between" v-if="hor.marcacao.paciente">
            <div v-if="hor.marcacao.paciente.cadastro && hor.marcacao.paciente.cadastro.telefone_cadastros">
                <div v-for="(tel, it) in hor.marcacao.paciente.cadastro.telefone_cadastros" :key="it">
                    <i class="fas fa-phone mr-1" v-if="tel.telefone.ch_tipo_telefone == 'R'"></i>
                    <i class="fas fa-mobile-alt mr-1" v-if="tel.telefone.ch_tipo_telefone == 'M'"></i>
                    <small>
                        {{ telefone(tel.telefone.st_numero, tel.telefone.st_cod_pais) }}
                    </small>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between" v-else-if="hor.marcacao.cadastro_temporario">
            <div>
                <div v-if="hor.marcacao.cadastro_temporario.st_telefone">
                    <i class="fas fa-phone mr-1"></i>
                    <small>
                        {{ telefone(hor.marcacao.cadastro_temporario.st_telefone) }}
                    </small>
                </div>
                <div v-if="hor.marcacao.cadastro_temporario.st_celular">
                    <i class="fas fa-mobile-alt mr-1"></i>
                    <small>
                        {{ telefone(hor.marcacao.cadastro_temporario.st_celular, hor.marcacao.cadastro_temporario.st_cod_pais) }}
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['hor'],

    methods: { 
        telefone (telefone, cod_pais = null) { 

            if ( cod_pais && cod_pais == '+' ) { 
                return cod_pais + telefone;
            }

            let numb = telefone.match(/\d/g);

            if ( !numb )
                return;

            numb = numb.join("");

            let textoAjustado = "";

            if ( numb.length == 8 ) {
                const parte1 = numb.slice(0,4);
                const parte2 = numb.slice(4,8);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`;
            } else if ( numb.length == 9 ) {        
                const parte1 = numb.slice(0,5);
                const parte2 = numb.slice(5,9);
                textoAjustado = textoAjustado + `${parte1}-${parte2}`;
            } else { 
                textoAjustado = "(" + numb.slice(0,2) + ") ";
                if(numb.length == 11) {
                    const parte1 = numb.slice(2,7);
                    const parte2 = numb.slice(7,11);
                    textoAjustado = textoAjustado + `${parte1}-${parte2}`        
                } else {
                    const parte1 = numb.slice(2,6);
                    const parte2 = numb.slice(6,10);
                    textoAjustado = textoAjustado + `${parte1}-${parte2}`
                }
            }

            return textoAjustado;
        }
    }
}
</script>